// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3fDZI","header":"MessagesList_header__35QtN","chat":"MessagesList_chat__3fkRT"};